/* tslint:disable */
import {
  CompanyAccount,
  PropertyUnits,
  Lease
} from '../index';

declare var Object: any;
export interface PropertyBadDebtInterface {
  "property_id": number;
  "property_unit_id": number;
  "lease_id": number;
  "chart_of_account_id"?: number;
  "amount": number;
  "id"?: number;
  "createdAt": Date;
  "updatedAt": Date;
  "deletedAt"?: Date;
  property?: CompanyAccount;
  propertyUnit?: PropertyUnits;
  lease?: Lease;
}

export class PropertyBadDebt implements PropertyBadDebtInterface {
  "property_id": number;
  "property_unit_id": number;
  "lease_id": number;
  "chart_of_account_id": number;
  "amount": number;
  "id": number;
  "createdAt": Date;
  "updatedAt": Date;
  "deletedAt": Date;
  property: CompanyAccount;
  propertyUnit: PropertyUnits;
  lease: Lease;
  constructor(data?: PropertyBadDebtInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `PropertyBadDebt`.
   */
  public static getModelName() {
    return "PropertyBadDebt";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of PropertyBadDebt for dynamic purposes.
  **/
  public static factory(data: PropertyBadDebtInterface): PropertyBadDebt{
    return new PropertyBadDebt(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'PropertyBadDebt',
      plural: 'PropertyBadDebts',
      path: 'PropertyBadDebts',
      idName: 'id',
      properties: {
        "property_id": {
          name: 'property_id',
          type: 'number'
        },
        "property_unit_id": {
          name: 'property_unit_id',
          type: 'number'
        },
        "lease_id": {
          name: 'lease_id',
          type: 'number'
        },
        "chart_of_account_id": {
          name: 'chart_of_account_id',
          type: 'number'
        },
        "amount": {
          name: 'amount',
          type: 'number'
        },
        "id": {
          name: 'id',
          type: 'number'
        },
        "createdAt": {
          name: 'createdAt',
          type: 'Date'
        },
        "updatedAt": {
          name: 'updatedAt',
          type: 'Date'
        },
        "deletedAt": {
          name: 'deletedAt',
          type: 'Date',
          default: new Date(0)
        },
      },
      relations: {
        property: {
          name: 'property',
          type: 'CompanyAccount',
          model: 'CompanyAccount',
          relationType: 'belongsTo',
                  keyFrom: 'property_id',
          keyTo: 'id'
        },
        propertyUnit: {
          name: 'propertyUnit',
          type: 'PropertyUnits',
          model: 'PropertyUnits',
          relationType: 'belongsTo',
                  keyFrom: 'property_unit_id',
          keyTo: 'id'
        },
        lease: {
          name: 'lease',
          type: 'Lease',
          model: 'Lease',
          relationType: 'belongsTo',
                  keyFrom: 'lease_id',
          keyTo: 'id'
        },
      }
    }
  }
}
